var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhotos = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#0E0F0F",
  clipPath: "url(#istock-photos-icon)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.347 5.889c-1.91 0-3.463 1.576-3.463 3.515 0 1.938 1.553 3.514 3.463 3.514 1.909 0 3.463-1.576 3.463-3.514 0-1.939-1.554-3.515-3.463-3.515m0 5.53c-1.082 0-1.963-.904-1.963-2.015s.88-2.015 1.963-2.015c1.082 0 1.963.903 1.963 2.015 0 1.11-.881 2.014-1.963 2.014ZM3.95 5.427a.82.82 0 0 0-.814.83c0 .457.364.829.814.829a.82.82 0 0 0 .813-.83.82.82 0 0 0-.813-.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.857 2.188H12.07L11.334.69a1.26 1.26 0 0 0-1.139-.713H6.498a1.26 1.26 0 0 0-1.139.712l-.736 1.5H1.835A1.85 1.85 0 0 0 0 4.043V14.86c0 1.023.823 1.856 1.835 1.856h13.022a1.85 1.85 0 0 0 1.835-1.856V4.044a1.85 1.85 0 0 0-1.835-1.856m.335 12.672c0 .193-.153.356-.335.356H1.835c-.182 0-.335-.163-.335-.356V4.044c0-.192.153-.356.335-.356H4.77a1.26 1.26 0 0 0 1.137-.712l.737-1.5h3.405l.735 1.5c.216.439.652.712 1.14.712h2.933c.182 0 .335.164.335.356z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "istock-photos-icon"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16.692v16.692H0z"
})))));
export default SvgPhotos;